/* Marinelie — die Chips im Suchraum des Schubfachs.

   Sie waren bis zum 20.09.2026 nur Abkuerzungen ins Suchfeld: ein Klick
   schrieb den Begriff hinein und stiess Shopifys Vorschlagssuche an. Das
   sah nach Filter aus und war keiner — im Gegenteil, sobald etwas im Feld
   stand, blendete `.mln__suchfeld[open] .mln__beliebt` die Liste darunter
   ganz aus. Man konnte also nichts auswaehlen, man loeschte nur, was man
   sehen wollte (Otton: "hier kann man noch nichts auswaehlen mit filter").

   Jetzt filtern sie die Liste selbst. Die Daten dafuer liegen laengst am
   Produkt und werden in `ml-suchzeile.liquid` an die Zeile geschrieben:
   die Tags tragen den Anlass, custom.sillage_tag die Staerke.

   Eine Reihe verhaelt sich wie ein Radio — ein zweiter Chip loest den
   ersten ab, derselbe Chip noch einmal hebt ihn auf. Zwischen den Reihen
   gilt UND: "Fuer Winter" und "Loud" zeigt, was beides ist. Chips mit
   einem Pfad sind Links und bleiben, was sie sind.

   ---------------------------------------------------------------------
   Fassung vom 20.09.2026, nach "und diese filter funktionen funktionieren
   noch nicht".

   Die erste Fassung hat beim Laden einmal alle Chips gesucht und an jeden
   einzeln einen Listener gehaengt. Das haelt nur, solange dieselben
   Knoten stehen bleiben — und der Kopf ist eine Shopify-Section: jedes
   Cart-Update, jeder Section-Rendering-Aufruf und jedes Speichern im
   Theme-Editor ersetzt sein Markup komplett. Danach stehen dieselben
   Chips da, ohne dass irgendetwas an ihnen haengt, und ein Klick tut
   sichtbar nichts. Genauso, wenn das Schubfach ueberhaupt erst nach dem
   Skript in den Baum kommt.

   Deshalb haengt jetzt EIN Listener am Dokument und die Knoten werden bei
   jedem Klick frisch gesucht. Es gibt nichts mehr, was veralten kann. Die
   Wahl liegt am `.mln__suchfeld` selbst, nicht in einer Closure, damit sie
   einen Section-Neuaufbau ueberlebt, solange das Element steht.

   ---------------------------------------------------------------------
   Und die eigentliche Ursache, am 20.09.2026 am echten Laden nachgestellt
   (Playwright, eingeloggt): die Filter HABEN gerechnet. Nach einem Klick
   auf "Fuer Winter" stand der Titel auf "5 Duefte" und genau die fuenf
   passenden Zeilen hatten `is-weg` verloren. Nur war in derselben
   Sekunde der ganze Suchraum auf `display: none` gefallen.

   Grund: der Raum hing an `.mln__suchfeld:focus-within`. Ein Klick auf
   einen Chip nimmt dem Eingabefeld den Fokus — der Chip liegt im selben
   Element, aber ein <button> bekommt beim Klick nicht ueberall Fokus,
   auf macOS grundsaetzlich nicht. Der Raum klappte also zu, sobald man
   ihn benutzte.

   Der Zustand haengt jetzt an der Klasse `is-suche` auf `.mln`. Fokus
   oeffnet ihn, aber nur "Menue", das Kreuz oder Escape schliessen ihn.
   Damit kann kein verlorener Fokus mehr etwas wegnehmen. */
(function () {
  'use strict';

  var FELD = '.mln__suchfeld';

  function sauber(wert) {
    return (wert || '').toString().trim().toLowerCase();
  }

  function alle(wurzel, wahl) {
    return Array.prototype.slice.call(wurzel.querySelectorAll(wahl));
  }

  /* Welche Reihe ein Chip bedient, steht nicht im Markup — es ergibt sich
     daraus, in welchem `.mln__chips` er haengt. So braucht die
     Liquid-Seite kein zusaetzliches Attribut, und eine dritte Reihe
     funktioniert ohne Aenderung hier. */
  function reiheVon(chip) {
    var gruppe = chip.closest('.mln__chips');
    if (!gruppe) return 'frei';
    return gruppe.classList.contains('mln__chips--staerke') ? 'staerke' : 'anlass';
  }

  /* Die Wahl haengt am Feld, nicht an dieser Datei. */
  function wahlVon(feld) {
    if (!feld.__mlWahl) feld.__mlWahl = {};
    return feld.__mlWahl;
  }

  function anzahlGewaehlt(wahl) {
    var n = 0;
    for (var r in wahl) {
      if (Object.prototype.hasOwnProperty.call(wahl, r) && wahl[r]) n++;
    }
    return n;
  }

  function passt(zeile, wahl) {
    var tags = sauber(zeile.getAttribute('data-ml-tags'));
    var sillage = sauber(zeile.getAttribute('data-ml-sillage'));
    for (var reihe in wahl) {
      if (!Object.prototype.hasOwnProperty.call(wahl, reihe)) continue;
      var wort = wahl[reihe];
      if (!wort) continue;
      if (reihe === 'staerke') {
        if (sillage !== wort) return false;
      } else if (tags.indexOf(',' + wort + ',') === -1) {
        return false;
      }
    }
    return true;
  }

  function zeichne(feld) {
    if (!feld) return;
    var wahl = wahlVon(feld);

    alle(feld, '[data-suche-chip]').forEach(function (c) {
      var wort = sauber(c.getAttribute('data-suche-chip'));
      c.classList.toggle('is-gewaehlt', wahl[reiheVon(c)] === wort);
    });

    var liste = feld.querySelector('[data-ml-beliebt]');
    if (!liste) return;

    var zeilen = alle(liste, '.mln__zeile-treffer');
    var listenTitel = liste.querySelector('[data-ml-beliebt-titel]');
    var leerZeile = liste.querySelector('[data-ml-beliebt-leer]');
    var listenRuhe = liste.getAttribute('data-ml-titel-ruhe') || '';
    var standard = parseInt(liste.getAttribute('data-ml-standard'), 10);
    if (!standard || standard < 1) standard = 3;

    if (anzahlGewaehlt(wahl) === 0) {
      /* Zurueck in den Ruhezustand: die ersten drei stehen, der Rest legt
         sich wieder hin. */
      zeilen.forEach(function (z, i) { z.classList.toggle('is-weg', i >= standard); });
      if (leerZeile) leerZeile.classList.add('is-weg');
      if (listenTitel && listenRuhe) listenTitel.textContent = listenRuhe;
      liste.classList.remove('is-gefiltert');
      return;
    }

    var treffer = 0;
    zeilen.forEach(function (z) {
      var ja = passt(z, wahl);
      z.classList.toggle('is-weg', !ja);
      if (ja) treffer++;
    });

    if (leerZeile) leerZeile.classList.toggle('is-weg', treffer > 0);
    if (listenTitel) {
      listenTitel.textContent = treffer === 1 ? '1 Duft' : treffer + ' Düfte';
    }
    liste.classList.add('is-gefiltert');
  }

  function raum(feld) {
    return feld ? feld.closest('.mln') : null;
  }

  function oeffne(feld) {
    var mln = raum(feld);
    if (mln) mln.classList.add('is-suche');
  }

  function schliesse(mln) {
    if (!mln) return;
    mln.classList.remove('is-suche');
    var feld = mln.querySelector(FELD);
    if (feld) {
      feld.__mlWahl = {};
      var eingabe = feld.querySelector('input[type="search"]');
      if (eingabe) {
        eingabe.value = '';
        /* Kein blur(). Dawns MenuDrawer haengt an `focusout` und schliesst
           das GANZE Schubfach, sobald document.activeElement es verlaesst
           (global.js, onFocusOut). Ein blur legt den Fokus auf <body> —
           damit war das Schubfach weg, statt nur der Suchraum, und der
           naechste Tap landete auf der Seite dahinter. Am Laden mit
           einem Mutation-Log nachgestellt.

           Deshalb wandert der Fokus auf "Menue". Der Knopf steht im
           Schubfach, also bleibt es offen, und die Tastatur landet an
           genau der Stelle, an der man gerade gedrueckt hat. */
        if (feld.contains(document.activeElement)) {
          var ziel = mln.querySelector('[data-mln-zurueck]');
          if (ziel) ziel.focus();
        }
      }
      zeichne(feld);
    }

    /* Der Suchraum ist hoch — wer ihn ganz unten verlaesst, stuende sonst
       mitten im Menue statt an dessen Anfang. Am Laden aufgefallen: nach
       dem Rueckweg lag der Kopf des Schubfachs ausserhalb des Bildes.

       Nicht mit scrollIntoView: das scrollt das Fenster mit und schiebt
       damit das ganze Schubfach unter dem Finger weg — im Test landete
       der naechste Tap auf der Seite dahinter. Stattdessen genau der
       Container, der wirklich scrollt, und nur der. */
    var n = mln;
    while (n && n !== document.body) {
      if (n.scrollHeight > n.clientHeight + 1) { n.scrollTop = 0; break; }
      n = n.parentElement;
    }
  }

  /* Fassen ins Feld oeffnet den Raum. Fokus allein schliesst ihn nie
     wieder — genau das war der Fehler.

     Zwei Wege hinein, absichtlich: `focusin` faengt Tastatur und Tab,
     `pointerdown` faengt den Tap auch dort, wo der Fokus erst verzoegert
     oder gar nicht umspringt. Doppelt ausgeloest schadet nicht, die
     Klasse wird nur gesetzt. */
  document.addEventListener('focusin', function (e) {
    var feld = e.target.closest ? e.target.closest(FELD) : null;
    if (feld) oeffne(feld);
  });

  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest) return;
    var feld = e.target.closest(FELD);
    if (feld) oeffne(feld);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var offen = document.querySelector('.mln.is-suche');
    if (offen) schliesse(offen);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* "Menue" im Kopf ist der Rueckweg. */
    var zurueck = e.target.closest('[data-mln-zurueck]');
    if (zurueck) {
      var mln = zurueck.closest('.mln');
      if (mln && mln.classList.contains('is-suche')) {
        e.preventDefault();
        schliesse(mln);
      }
      return;
    }

    var chip = e.target.closest('[data-suche-chip]');
    if (!chip) return;
    var feld = chip.closest(FELD);
    if (!feld) return;

    var wahl = wahlVon(feld);
    var reihe = reiheVon(chip);
    var wort = sauber(chip.getAttribute('data-suche-chip'));
    wahl[reihe] = wahl[reihe] === wort ? '' : wort;
    zeichne(feld);
  });

  /* Sobald jemand selbst tippt, sind die Chips nicht mehr gemeint:
     Shopifys Vorschlaege uebernehmen den Raum, und die Liste darunter ist
     ohnehin ausgeblendet. Die Wahl wird deshalb aufgehoben, damit sie
     nicht unsichtbar weiterwirkt. */
  document.addEventListener('input', function (e) {
    var eingabe = e.target;
    if (!eingabe || eingabe.type !== 'search') return;
    var feld = eingabe.closest ? eingabe.closest(FELD) : null;
    if (!feld) return;

    var wert = (eingabe.value || '').trim();
    if (wert && anzahlGewaehlt(wahlVon(feld)) > 0) {
      feld.__mlWahl = {};
      zeichne(feld);
    }
    var titel = feld.querySelector('[data-suche-chiptitel]');
    if (titel) {
      titel.textContent = wert ? 'Suche verfeinern' : (titel.getAttribute('data-titel-ruhe') || '');
    }
  });

  /* Einmal beim Laden und nach jedem Section-Neuaufbau in den
     Ruhezustand zeichnen — sonst stuenden nach einem Cart-Update alle
     zwoelf Zeilen offen da, weil `is-weg` aus dem Markup nur die
     Anfangslage ist. */
  function anfang() {
    document.querySelectorAll(FELD).forEach(function (feld) { zeichne(feld); });
  }

  /* Schliesst sich das Schubfach, faellt es beim naechsten Oeffnen auf
     das Menue zurueck — sonst stuende dort noch der Suchraum von vorhin,
     und der Nutzer kaeme wieder im falschen Zustand an. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || d.open) return;
    var mln = d.querySelector ? d.querySelector('.mln.is-suche') : null;
    if (mln) schliesse(mln);
  }, true);

  document.addEventListener('shopify:section:load', anfang);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anfang);
  } else {
    anfang();
  }
})();
